export default "__VITE_ASSET__DW7A6ghu__"